import {IS_UNIQUE, OTP, OTP_REG_LOGIN} from "../../helpers/constants/url";
import baseApi from "./baseApiEndpoints";

// Define a service using a base URL and expected endpoints
export const validationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    isunique: builder.mutation({
      query: (credentials) => ({
        url: `${IS_UNIQUE}`,
        method: "POST",
        body: credentials,
      })
    }),
    sendOtp: builder.mutation({
      query: (credentials) => ({
        url: `${OTP}`,
        method: "POST",
        body: credentials,
      })
    }),
    createAccountWithOtp: builder.mutation({
      query: (credentials) => ({
        url: `${OTP_REG_LOGIN}`,
        method: "POST",
        body: credentials,
      })
    }),
  }),
  overrideExisting: false,
});

export const { useIsuniqueMutation, useSendOtpMutation, useCreateAccountWithOtpMutation } = validationApi;
